import { render, staticRenderFns } from "./CharactersCenter.vue?vue&type=template&id=1a690a66&scoped=true&"
import script from "./CharactersCenter.vue?vue&type=script&lang=js&"
export * from "./CharactersCenter.vue?vue&type=script&lang=js&"
import style0 from "./CharactersCenter.vue?vue&type=style&index=0&id=1a690a66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a690a66",
  null
  
)

export default component.exports